export const LANGS = [
  { code: "fr", label: "Français", short: "FR" },
  { code: "en", label: "English", short: "EN" },
];

export const MONTHS = {
  fr: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
  en: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
};

export const MONTHS_SHORT = {
  fr: ["Janv", "Févr", "Mars", "Avr", "Mai", "Juin", "Juil", "Août", "Sept", "Oct", "Nov", "Déc"],
  en: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
};

export const STATUS_LABELS = {
  fr: {
    "EN ATTENTE DE PAIEMENT": "En attente de paiement",
    "PAYEE": "Payée",
    "EN COURS DE PRODUCTION": "En production",
    "LIVREE": "Livrée",
  },
  en: {
    "EN ATTENTE DE PAIEMENT": "Awaiting payment",
    "PAYEE": "Paid",
    "EN COURS DE PRODUCTION": "In production",
    "LIVREE": "Delivered",
  },
};

const dict = {
  fr: {
    "common.loading": "Chargement…",
    "common.cancel": "Annuler",
    "common.save": "Enregistrer",
    "common.logout": "Déconnexion",
    "common.email": "Email",
    "common.password": "Mot de passe",
    "common.back_login": "Retour à la connexion",
    "common.language": "Langue",
    "common.videos": "vidéos",
    "common.order": "commande",
    "common.orders": "commandes",
    "common.actions": "Actions",
    "common.date": "Date",
    "common.status": "Statut",
    "common.price": "Prix",
    "common.confirm_delete": "Confirmer la suppression ?",

    "login.eyebrow": "Connexion",
    "login.title": "Accédez à votre espace",
    "login.subtitle": "Administrateurs et clients — même porte d'entrée.",
    "login.brand_l1": "Le studio",
    "login.brand_l2": "qui monte",
    "login.brand_l3": "vos idées.",
    "login.brand_sub": "Gérez vos packs vidéo, suivez vos commandes et livrez vos montages — le tout en un seul espace.",
    "login.email_ph": "vous@exemple.com",
    "login.forgot": "Mot de passe oublié ?",
    "login.submit": "Se connecter",
    "login.welcome": "Bienvenue sur CH CREATIVE",
    "login.error": "Connexion impossible",

    "forgot.eyebrow": "Récupération",
    "forgot.title": "Mot de passe oublié",
    "forgot.subtitle": "Saisissez votre email pour recevoir un lien de réinitialisation.",
    "forgot.submit": "Envoyer le lien",
    "forgot.sent_title": "Vérifiez vos emails",
    "forgot.sent_body": "Si cet email est enregistré, un lien de réinitialisation vient d'être envoyé. Il expire dans 1 heure.",

    "reset.eyebrow": "Nouveau mot de passe",
    "reset.title": "Réinitialisation",
    "reset.newpw": "Nouveau mot de passe",
    "reset.confirm": "Confirmer",
    "reset.submit": "Réinitialiser",
    "reset.invalid": "Lien invalide : jeton manquant.",
    "reset.mismatch": "Les mots de passe ne correspondent pas",
    "reset.min": "Au moins 6 caractères",
    "reset.success": "Mot de passe réinitialisé",

    "nav.home": "Accueil",
    "nav.active_orders": "Commandes en cours",
    "nav.clients": "Clients",
    "nav.packages": "Packages vidéo",
    "nav.orders": "Commandes",
    "nav.archives": "Archives",
    "nav.contact": "Contact",
    "cnav.orders": "Mes commandes",
    "cnav.order": "Commander",
    "cnav.account": "Compte",
    "cnav.help": "Contact / Aide",

    "home.eyebrow": "Tableau de bord",
    "home.title": "Accueil",
    "kpi.videos_edited": "Vidéos éditées ce mois",
    "kpi.revenue": "CA ce mois",
    "kpi.revenue_year": "CA année",
    "kpi.pending": "Vidéos à éditer",
    "kpi.clients": "Clients",
    "chart.videos": "Vidéos éditées / mois",
    "chart.revenue": "Chiffre d'affaires / mois",
    "chart.orders": "Commandes passées / mois",

    "ao.eyebrow": "Production",
    "ao.subtitle": "Cliquez sur une commande pour ajouter les liens de vidéos éditées.",
    "ao.remaining": "Vidéos restantes",
    "ao.remaining_label": "vidéos restantes",
    "ao.empty": "Aucune commande en cours.",
    "ao.per_video": "s / vidéo",
    "ao.video_links": "Liens des vidéos éditées",
    "ao.no_videos": "Aucune vidéo ajoutée.",
    "ao.title_ph": "Titre (optionnel)",
    "ao.edit_title": "Modifier le nom",
    "ao.title_updated": "Nom mis à jour",
    "ao.save_title": "Enregistrer",
    "ao.video_added": "Vidéo ajoutée",
    "ao.resend_email": "Renvoyer l'email de livraison",
    "ao.resend_sent": "Email renvoyé au client",
    "ao.need_link": "Ajoutez un lien de vidéo",
    "ao.pack_done": "Pack complété — commande livrée",
    "ao.status_updated": "Statut mis à jour",
    "ao.col_client": "Client",
    "ao.col_pack": "Pack",

    "clients.eyebrow": "Répertoire",
    "clients.new": "Nouveau client",
    "clients.edit": "Modifier le client",
    "clients.empty": "Aucun client pour le moment.",
    "clients.created": "Client créé",
    "clients.updated": "Client mis à jour",
    "clients.deleted": "Client supprimé",
    "clients.del_confirm": "Supprimer ce client ? Ses commandes seront aussi supprimées.",
    "clients.firstname": "Prénom",
    "clients.lastname": "Nom",
    "clients.company": "Société",
    "clients.phone": "Téléphone",
    "clients.pw_keep": "(laisser vide pour conserver)",
    "clients.pw_ph": "Mot de passe du client",

    "pkg.eyebrow": "Offres",
    "pkg.new": "Nouveau pack",
    "pkg.edit": "Modifier le pack",
    "pkg.empty": "Aucun pack. Créez votre première offre.",
    "pkg.created": "Pack créé",
    "pkg.updated": "Pack mis à jour",
    "pkg.deleted": "Pack supprimé",
    "pkg.del_confirm": "Supprimer ce pack ?",
    "pkg.name": "Nom du pack",
    "pkg.description": "Description",
    "pkg.description_ph": "Décrivez ce que comprend ce pack…",
    "pkg.count": "Nombre de vidéos",
    "pkg.count_label": "vidéos éditées",
    "pkg.seconds": "Secondes / vidéo",
    "pkg.seconds_label": "par vidéo",
    "pkg.validity": "Validité (mois)",
    "pkg.validity_label": "Validité",
    "pkg.months": "mois",
    "pkg.per_video": "/ vidéo",
    "pkg.active": "Pack actif (visible par les clients)",
    "pkg.inactive": "Inactif",
    "pkg.price_per_video": "Prix par vidéo :",

    "ord.eyebrow": "Gestion",
    "ord.new": "Nouvelle commande",
    "ord.edit": "Modifier la commande",
    "ord.empty": "Aucune commande.",
    "ord.created": "Commande créée",
    "ord.updated": "Commande mise à jour",
    "ord.deleted": "Commande supprimée",
    "ord.del_confirm": "Supprimer cette commande ?",
    "ord.need_fields": "Sélectionnez un client et un pack",
    "ord.client": "Client",
    "ord.pick_client": "Choisir un client",
    "ord.pack": "Pack vidéo",
    "ord.pick_pack": "Choisir un pack",

    "arch.eyebrow": "Historique",
    "arch.subtitle_admin": "Commandes livrées, regroupées mois par mois.",
    "arch.subtitle_client": "Vos commandes livrées, regroupées mois par mois.",
    "arch.empty_admin": "Aucune commande archivée pour l'instant.",
    "arch.empty_client": "Aucune commande livrée pour l'instant.",
    "arch.videos_delivered": "vidéos livrées",
    "arch.view_videos": "Cliquez pour voir les vidéos livrées.",

    "contact.eyebrow_admin": "Messagerie",
    "contact.subtitle_admin": "Messages reçus des clients. Répondez, modifiez ou supprimez.",
    "contact.empty_admin": "Aucun message pour l'instant.",
    "contact.from": "De",
    "contact.your_reply": "Votre réponse",
    "contact.reply_ph": "Votre réponse…",
    "contact.reply_edit_ph": "Modifier / renvoyer une réponse…",
    "contact.reply_btn": "Répondre",
    "contact.you": "Vous",
    "contact.send": "Envoyer",
    "contact.reply_placeholder": "Écrire un message…",
    "contact.update_btn": "Mettre à jour",
    "contact.reply_sent": "Réponse envoyée",
    "contact.reply_empty": "Écrivez une réponse",
    "contact.msg_updated": "Message mis à jour",
    "contact.msg_deleted": "Message supprimé",
    "contact.del_confirm": "Supprimer ce message définitivement ?",
    "contact.edit_msg": "Modifier le message",
    "contact.subject": "Sujet",
    "contact.message": "Message",

    "ch.title": "Mes commandes en cours",
    "ch.hello": "Bonjour",
    "ch.cta": "Passer une commande",
    "ch.empty": "Aucune commande en cours.",
    "ch.discover": "Découvrir les packs",
    "ch.remaining_in_pack": "Vidéos restantes dans le pack",
    "ch.delivered_videos": "Vidéos livrées",

    "co.eyebrow": "Nos offres",
    "co.title": "Passer une commande",
    "co.subtitle": "Choisissez le pack vidéo adapté à vos besoins.",
    "co.order_btn": "Commander",
    "co.empty": "Aucun pack disponible pour le moment.",
    "co.saved": "Commande enregistrée",

    "acc.eyebrow": "Mon espace",
    "acc.title": "Compte",
    "acc.my_paid": "Mes commandes payées",
    "acc.no_paid": "Aucune commande payée.",
    "acc.invoice": "Facture",
    "acc.invoice_error": "Impossible de générer la facture",

    "help.eyebrow": "Support",
    "help.title": "Contact / Aide",
    "help.subtitle": "Une question ? Écrivez-nous, nous vous répondons ici.",
    "help.name": "Nom",
    "help.subject": "Sujet",
    "help.subject_ph": "Objet de votre message",
    "help.message": "Message",
    "help.message_ph": "Votre message…",
    "help.send": "Envoyer",
    "help.sent": "Message envoyé",
    "help.need_fields": "Sujet et message requis",
    "help.my_messages": "Mes messages",
    "help.no_messages": "Aucun message envoyé.",
    "help.reply_from": "Réponse de CH CREATIVE",
    "help.awaiting": "En attente de réponse…",
    "help.you": "Vous",
    "help.reply_here": "Répondre",
    "help.reply_ph": "Écrire un message…",
  },

  en: {
    "common.loading": "Loading…",
    "common.cancel": "Cancel",
    "common.save": "Save",
    "common.logout": "Log out",
    "common.email": "Email",
    "common.password": "Password",
    "common.back_login": "Back to login",
    "common.language": "Language",
    "common.videos": "videos",
    "common.order": "order",
    "common.orders": "orders",
    "common.actions": "Actions",
    "common.date": "Date",
    "common.status": "Status",
    "common.price": "Price",
    "common.confirm_delete": "Confirm deletion?",

    "login.eyebrow": "Login",
    "login.title": "Access your workspace",
    "login.subtitle": "Admins and clients — same entrance.",
    "login.brand_l1": "The studio",
    "login.brand_l2": "that edits",
    "login.brand_l3": "your ideas.",
    "login.brand_sub": "Manage your video packs, track your orders and deliver your edits — all in one place.",
    "login.email_ph": "you@example.com",
    "login.forgot": "Forgot password?",
    "login.submit": "Sign in",
    "login.welcome": "Welcome to CH CREATIVE",
    "login.error": "Unable to sign in",

    "forgot.eyebrow": "Recovery",
    "forgot.title": "Forgot password",
    "forgot.subtitle": "Enter your email to receive a reset link.",
    "forgot.submit": "Send link",
    "forgot.sent_title": "Check your email",
    "forgot.sent_body": "If this email is registered, a reset link has just been sent. It expires in 1 hour.",

    "reset.eyebrow": "New password",
    "reset.title": "Reset",
    "reset.newpw": "New password",
    "reset.confirm": "Confirm",
    "reset.submit": "Reset",
    "reset.invalid": "Invalid link: missing token.",
    "reset.mismatch": "Passwords do not match",
    "reset.min": "At least 6 characters",
    "reset.success": "Password reset",

    "nav.home": "Home",
    "nav.active_orders": "Orders in progress",
    "nav.clients": "Clients",
    "nav.packages": "Video packages",
    "nav.orders": "Orders",
    "nav.archives": "Archives",
    "nav.contact": "Contact",
    "cnav.orders": "My orders",
    "cnav.order": "Order",
    "cnav.account": "Account",
    "cnav.help": "Contact / Help",

    "home.eyebrow": "Dashboard",
    "home.title": "Home",
    "kpi.videos_edited": "Videos edited this month",
    "kpi.revenue": "Revenue this month",
    "kpi.revenue_year": "Revenue this year",
    "kpi.pending": "Videos to edit",
    "kpi.clients": "Clients",
    "chart.videos": "Videos edited / month",
    "chart.revenue": "Revenue / month",
    "chart.orders": "Orders placed / month",

    "ao.eyebrow": "Production",
    "ao.subtitle": "Click an order to add the edited video links.",
    "ao.remaining": "Videos left",
    "ao.remaining_label": "videos left",
    "ao.empty": "No orders in progress.",
    "ao.per_video": "s / video",
    "ao.video_links": "Edited video links",
    "ao.no_videos": "No video added.",
    "ao.title_ph": "Title (optional)",
    "ao.edit_title": "Edit name",
    "ao.title_updated": "Name updated",
    "ao.save_title": "Save",
    "ao.video_added": "Video added",
    "ao.resend_email": "Resend delivery email",
    "ao.resend_sent": "Email resent to the client",
    "ao.need_link": "Add a video link",
    "ao.pack_done": "Pack complete — order delivered",
    "ao.status_updated": "Status updated",
    "ao.col_client": "Client",
    "ao.col_pack": "Pack",

    "clients.eyebrow": "Directory",
    "clients.new": "New client",
    "clients.edit": "Edit client",
    "clients.empty": "No clients yet.",
    "clients.created": "Client created",
    "clients.updated": "Client updated",
    "clients.deleted": "Client deleted",
    "clients.del_confirm": "Delete this client? Their orders will also be deleted.",
    "clients.firstname": "First name",
    "clients.lastname": "Last name",
    "clients.company": "Company",
    "clients.phone": "Phone",
    "clients.pw_keep": "(leave empty to keep)",
    "clients.pw_ph": "Client password",

    "pkg.eyebrow": "Offers",
    "pkg.new": "New pack",
    "pkg.edit": "Edit pack",
    "pkg.empty": "No packs. Create your first offer.",
    "pkg.created": "Pack created",
    "pkg.updated": "Pack updated",
    "pkg.deleted": "Pack deleted",
    "pkg.del_confirm": "Delete this pack?",
    "pkg.name": "Pack name",
    "pkg.description": "Description",
    "pkg.description_ph": "Describe what this pack includes…",
    "pkg.count": "Number of videos",
    "pkg.count_label": "edited videos",
    "pkg.seconds": "Seconds / video",
    "pkg.seconds_label": "per video",
    "pkg.validity": "Validity (months)",
    "pkg.validity_label": "Validity",
    "pkg.months": "months",
    "pkg.per_video": "/ video",
    "pkg.active": "Active pack (visible to clients)",
    "pkg.inactive": "Inactive",
    "pkg.price_per_video": "Price per video:",

    "ord.eyebrow": "Management",
    "ord.new": "New order",
    "ord.edit": "Edit order",
    "ord.empty": "No orders.",
    "ord.created": "Order created",
    "ord.updated": "Order updated",
    "ord.deleted": "Order deleted",
    "ord.del_confirm": "Delete this order?",
    "ord.need_fields": "Select a client and a pack",
    "ord.client": "Client",
    "ord.pick_client": "Choose a client",
    "ord.pack": "Video pack",
    "ord.pick_pack": "Choose a pack",

    "arch.eyebrow": "History",
    "arch.subtitle_admin": "Delivered orders, grouped month by month.",
    "arch.subtitle_client": "Your delivered orders, grouped month by month.",
    "arch.empty_admin": "No archived orders yet.",
    "arch.empty_client": "No delivered orders yet.",
    "arch.videos_delivered": "videos delivered",
    "arch.view_videos": "Click to view delivered videos.",

    "contact.eyebrow_admin": "Messaging",
    "contact.subtitle_admin": "Messages received from clients. Reply, edit or delete.",
    "contact.empty_admin": "No messages yet.",
    "contact.from": "From",
    "contact.your_reply": "Your reply",
    "contact.reply_ph": "Your reply…",
    "contact.reply_edit_ph": "Edit / resend a reply…",
    "contact.reply_btn": "Reply",
    "contact.you": "You",
    "contact.send": "Send",
    "contact.reply_placeholder": "Write a message…",
    "contact.update_btn": "Update",
    "contact.reply_sent": "Reply sent",
    "contact.reply_empty": "Write a reply",
    "contact.msg_updated": "Message updated",
    "contact.msg_deleted": "Message deleted",
    "contact.del_confirm": "Delete this message permanently?",
    "contact.edit_msg": "Edit message",
    "contact.subject": "Subject",
    "contact.message": "Message",

    "ch.title": "My orders in progress",
    "ch.hello": "Hello",
    "ch.cta": "Place an order",
    "ch.empty": "No orders in progress.",
    "ch.discover": "Discover the packs",
    "ch.remaining_in_pack": "Videos left in the pack",
    "ch.delivered_videos": "Delivered videos",

    "co.eyebrow": "Our offers",
    "co.title": "Place an order",
    "co.subtitle": "Choose the video pack that fits your needs.",
    "co.order_btn": "Order",
    "co.empty": "No pack available at the moment.",
    "co.saved": "Order registered",

    "acc.eyebrow": "My space",
    "acc.title": "Account",
    "acc.my_paid": "My paid orders",
    "acc.no_paid": "No paid orders.",
    "acc.invoice": "Invoice",
    "acc.invoice_error": "Unable to generate the invoice",

    "help.eyebrow": "Support",
    "help.title": "Contact / Help",
    "help.subtitle": "A question? Write to us, we reply here.",
    "help.name": "Name",
    "help.subject": "Subject",
    "help.subject_ph": "Subject of your message",
    "help.message": "Message",
    "help.message_ph": "Your message…",
    "help.send": "Send",
    "help.sent": "Message sent",
    "help.need_fields": "Subject and message required",
    "help.my_messages": "My messages",
    "help.no_messages": "No message sent.",
    "help.reply_from": "Reply from CH CREATIVE",
    "help.awaiting": "Awaiting reply…",
    "help.you": "You",
    "help.reply_here": "Reply",
    "help.reply_ph": "Write a message…",
  },
};

export function translate(lang, key) {
  const l = dict[lang] ? lang : "fr";
  return dict[l][key] ?? dict.fr[key] ?? key;
}

export function statusLabel(lang, status) {
  const map = STATUS_LABELS[lang] || STATUS_LABELS.fr;
  return map[status] || status;
}

export function monthLabel(lang, month, year) {
  const arr = MONTHS[lang] || MONTHS.fr;
  return `${arr[month - 1]} ${year}`;
}
